// components/StatsDashboard.jsx
import React, { useEffect, useState } from 'react';
import api from '../api';
import Card from './ui/Card';
import CardContent from './ui/CardContent';
import Button from './ui/Button';

export default function StatsDashboard() {
  const [stats, setStats] = useState(null);
  const [visible, setVisible] = useState(false);


  useEffect(() => {
    if (!visible) return;

    const fetchStats = async () => {
      if (!localStorage.getItem("lyraToken")) {
        console.warn("No token found — user may not be logged in");
        return;
      }
      try {
        const res = await api.get("/stats");
        setStats(res.data);
      } catch (err) {
        if (err.response?.status === 401) {
          alert("Your session has expired. Please log in again.");
          localStorage.removeItem("lyraToken");
          window.location.reload();
        } else {
          console.error("Error fetching user stats:", err);
        }
      }
    };

    fetchStats();
  }, [visible]);

  return (
    <div className="space-y-4">
      <Button onClick={() => setVisible(!visible)}>
        {visible ? "Hide Stats" : "View Stats"}
      </Button>

      {visible && stats && (
        <Card>
          <CardContent>
            <h2 className="text-lg font-bold mb-2">Your Usage Stats</h2>
            <p>Total Prompts: {stats.totalPrompts}</p>
            <p>Optimized Prompts: {stats.optimizedPrompts}</p>
            <p>
              Last Used:{" "}
              {stats.lastUsed
                ? new Date(stats.lastUsed).toLocaleString()
                : "Never"}
            </p>
            <h3 className="font-semibold mt-4">Model Usage:</h3>
            {Object.keys(stats.modelUsage || {}).length === 0 ? (
              <p className="text-sm text-gray-500 mt-2">No usage yet.</p>
            ) : (
              <ul className="text-sm mt-2">
                {Object.entries(stats.modelUsage || {}).map(([model, count]) => (
                  <li key={model}>
                    {model}: {count}
                  </li>
                ))}
              </ul>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
